import { render } from "./BaseToggle.vue?vue&type=template&id=cd673a08&scoped=true&lang=pug"
import script from "./BaseToggle.vue?vue&type=script&lang=js"
export * from "./BaseToggle.vue?vue&type=script&lang=js"

import "./BaseToggle.vue?vue&type=style&index=0&id=cd673a08&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd673a08"]])

export default __exports__